module.exports = __webpack_public_path__ + "static/media/shaman_wand.fb6ed514.png";